module.exports = __webpack_public_path__ + "img/free.3ee606c4.svg";